import { useEffect } from "react";

const LOGO_NAVY_GOLD = "/praxis-logo.png";

export default function LandingLight() {
  useEffect(() => {
    document.title = "Praxis Sigma";
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute("content", "#FAF8F3");
  }, []);

  return (
    <main
      data-testid="landing-page-light"
      className="ps-light min-h-screen w-full flex flex-col"
      style={{ backgroundColor: "#FAF8F3" }}
    >
      <section
        data-testid="hero-section-light"
        className="w-full flex items-center justify-center px-6"
        style={{ paddingTop: "14vh", paddingBottom: "12vh" }}
      >
        <img
          data-testid="hero-logo-light"
          src={LOGO_NAVY_GOLD}
          alt="Praxis Sigma"
          className="ps-logo"
          style={{ mixBlendMode: "multiply" }}
        />
      </section>

      <div className="w-full flex justify-center">
        <span
          aria-hidden="true"
          style={{
            display: "block",
            height: "1px",
            width: "min(420px, 60%)",
            backgroundColor: "#B8952A",
          }}
        />
      </div>

      <section
        className="w-full flex flex-col items-center px-6"
        style={{ paddingTop: "10vh", paddingBottom: "10vh" }}
      >
        <p
          className="ps-statement text-center"
          style={{ color: "#1C2B4A" }}
        >
          We structure and manage private crypto futures joint ventures for a
          limited number of individually qualified capital partners. Engagements
          are conducted exclusively by private invitation.
        </p>
        <p
          className="ps-invitation text-center"
          style={{ color: "#B8952A", marginTop: "2.25rem" }}
        >
          We do not accept unsolicited inquiries.
        </p>
      </section>

      <section
        className="w-full flex justify-center px-6"
        style={{ paddingBottom: "14vh" }}
      >
        <a
          href="mailto:legal@praxissigma.com"
          className="ps-contact"
          style={{ color: "#1C2B4A" }}
        >
          legal@praxissigma.com
        </a>
      </section>

      <footer
        className="w-full mt-auto px-6"
        style={{
          paddingTop: "3rem",
          paddingBottom: "3rem",
          borderTop: "1px solid rgba(28, 43, 74, 0.18)",
        }}
      >
        <p
          className="ps-footer text-center mx-auto"
          style={{
            color: "rgba(28, 43, 74, 0.6)",
            maxWidth: "780px",
          }}
        >
          Praxis Sigma LLC is a private Wyoming limited liability company. This
          website does not constitute an offer to sell, a solicitation of an
          offer to buy, or a recommendation of any security, investment, or
          trading strategy. Engagements are conducted exclusively by referral
          and mutual introduction. Not intended for public distribution. © 2026
          Praxis Sigma LLC
        </p>
      </footer>
    </main>
  );
}
